import { useCurrentModule } from '../components';
import { useRecommendationRevealEnabled } from './useRecommendationRevealEnabled';
export const useAiAnalyzing = () => {
  const module = useCurrentModule();
  const {
    isEnabled
  } = useRecommendationRevealEnabled();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const plansRendered = module.SDK.aiRecommendationStore.useArePlansRendered();
  return isEnabled && plansRendered && !isDeciding && !isRevealed;
};
//# sourceMappingURL=useAiAnalyzing.js.map